import {Redirect, Route} from "react-router-dom";
import getHomePageUrl from "./HomePageUrl";
import checkUserAccess from "./UserAccess";
import {HB_ROUTE, HOME_ROUTE, SPS_ROUTE} from "../utils/storage-utils";
import HoneyBeeLandingPage from "../pages/HoneyBeeLandingPage";


const AuthenticatedRoute =({
    component: Component,
    authenticated,
    role,
    businessId,
    name,
    showModal,
    setClicked
}) => {
    
    const homePage = getHomePageUrl(role);
    const isRouteAllowed = checkUserAccess(role,name);
    const loginTypes = [HB_ROUTE, HOME_ROUTE, SPS_ROUTE]
    return (<Route
        render = { props =>
            authenticated === true ?
                isRouteAllowed ?
                    <Component {...props} role={role} businessId={businessId} showModal={showModal} setClicked={setClicked} />
                    :
                    <Redirect to={homePage} />
            :
                <HoneyBeeLandingPage />
        }
    />)
}
export default AuthenticatedRoute;